import React from "react";
import ReactDOM from "react-dom";
import Privacy from "../ui/Privacy";
import "../pages/coms/Coms.css";

interface PrivacyModalProps {
	open: boolean;
	onClose: () => void;
}

export const PrivacyModal: React.FC<PrivacyModalProps> = ({ open, onClose }) => {
	if (!open) return null;

	return ReactDOM.createPortal(
		<div
			className="privacy-modal-overlay"
			onClick={onClose}
		>
			<div
				className="privacy-modal-content"
				onClick={(e) => e.stopPropagation()}
			>
				<button
					className="close-button"
					onClick={onClose}
				>
					×
				</button>
				<div className="privacy-scrollable-wrapper">
					<Privacy />
				</div>
			</div>
		</div>,
		document.body
	);
};
